import React, { Component } from 'react'
import { CallDashboardTheme } from 'modules/theme'

export class CallDashboard extends Component {
    render() {
        return (
            <CallDashboardTheme
                dashboardHourlyTrendGraph={[65, 59, 80, 81, 56, 55, 40]}
            />
        )
    }
}

export default CallDashboard


// WEBPACK FOOTER //
// src/dialpad/components/layout/CallDashboard.js